<gcc-search-field class="search-input" (apply)="handleApply($event)" (clear)="clear()">
  <input
    class="form-control"
    type="text"
    [attr.placeholder]="placeholder"
    [value]="value"
    #search
    (keypress.enter)="handleApply(search.value)"
  />
</gcc-search-field>
